import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import AboutConstants from 'sharedreact/constants/AboutConstants';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

const Content: {
  show: boolean,
  versionInfo: string,
  legalNotices: string
} = {
  show: false,
  versionInfo: '',
  legalNotices: ''
};

class State extends Immutable.Record(Content) {
}

class AboutStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getShow (): boolean {
    return this.getState().show;
  }

  getVersionInfo (): string {
    return this.getState().versionInfo;
  }

  getLegalNotices (): string {
    return this.getState().legalNotices;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case AboutConstants.HIDE_ABOUT: {
        return state.set('show', false);
      }
      case AboutConstants.SHOW_ABOUT: {
        return state.set('show', true);
      }
      case AboutConstants.GET_SUCCESS: {
        return state.set('versionInfo', action.item.versionInfo)
      }
      case AboutConstants.GET_LEGAL_NOTICES_SUCCESS: {
        return state.set('legalNotices', action.legalNotices);
      }
      default: {
        return state;
      }
    }
  }
}

export default new AboutStore();
